import { create } from "zustand";
import { persist } from "zustand/middleware";

export type OSTheme = "light" | "dark";

type OSThemeState = {
  theme: OSTheme;
  setTheme: (t: OSTheme) => void;
  toggle: () => void;
};

export const useOSThemeStore = create<OSThemeState>()(
  persist(
    (set, get) => ({
      theme: "dark",
      setTheme: (t) => set({ theme: t }),
      toggle: () => set({ theme: get().theme === "dark" ? "light" : "dark" }),
    }),
    { name: "sc-os-theme" },
  ),
);
